// extracted by mini-css-extract-plugin
export default {"delivery_container":"custome-style_delivery_container__XYqNw","assign_to_me":"custome-style_assign_to_me__7Sr8Y"};